import { Text } from "@radix-ui/themes";

interface HeadingBlockProps {
  level: 1 | 2 | 3;
  text: string;
}

export function HeadingBlock({ level, text }: HeadingBlockProps) {
  const sizes = { 1: "6", 2: "4", 3: "3" } as const;
  const weights = { 1: "bold", 2: "bold", 3: "medium" } as const;

  if (level === 1) {
    return (
      <div>
        <Text
          as="p"
          size={sizes[level]}
          weight={weights[level]}
          className="text-puntt-neutral-gray-12"
        >
          {text}
        </Text>
        <div className="mt-1.5 h-1 w-12 rounded-full bg-puntt-accent-9" />
      </div>
    );
  }

  if (level === 2) {
    return (
      <Text
        as="p"
        size={sizes[level]}
        weight={weights[level]}
        className="border-l-[3px] border-puntt-accent-9 pl-3 text-puntt-neutral-gray-12"
      >
        {text}
      </Text>
    );
  }

  return (
    <Text
      as="p"
      size={sizes[level]}
      weight={weights[level]}
      className="text-puntt-neutral-gray-12"
    >
      {text}
    </Text>
  );
}
